<ps-ui-modal class="supplierModal" [showButtonClose]="false">
  <ps-ui-modal-body class="modal-dialog-scrollable supplierModal">
    <button
      type="button"
      class="btn-close btn-close-modal"
      (click)="close()"
    ></button>
    <ps-ui-edit-suppliers
      [surveyId]="data.surveyId"
      [eligibleSuppliers]="eligibleSuppliers"
      [showFooter]="false"
      [ir]="data.metadata.ir"
      [loi]="data.metadata.loi"
      [lang]="data.metadata.lang"
      [fieldTime]="data.metadata.fieldTime"
      [suppliers]="suppliers"
      [operatorOverrideCPI]="operatorOverrideCPI"
      [selectivePriceOveride]="selectivePriceOveride"
      [isPurePriceApplied]="isPurePriceApplied"
      [flexibilityPrice]="flexibilityPrice"
      [supplierBlendData]="supplierBlendData"
      [surveyDetails]="surveyDetails"
      [completesNeeded]="data.metadata.completesRequired"
      [isSurveyCreation]="true"
      [isInsights]="!!data.isInsights"
      (cpiOverrideConfirmationChange)="onCpiOverrideConfirmationChange($event)"
      (avgCpiThreshold)="onAvgCpiThreshold($event)"
      (changeSupplierRates)="onSupplierRates($event)"
    >
    </ps-ui-edit-suppliers>

    <ps-ui-modal-footer position="center">
      <button
        type="button"
        class="saveBtn"
        psUiButton
        (click)="updateSupplier()"
        *ngIf="true"
      >
        Save
      </button>
    </ps-ui-modal-footer>
  </ps-ui-modal-body>
</ps-ui-modal>
